import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { fireErrorAnalyticsEvents } from '../../../../common/utils';
import { fetchUserCapabilities as fetchUserCapabilitiesService } from '../../../../services/fetch-user-capabilities/index.tsx';
import type { State } from '../../types';

const EVENT_NAME = 'fetchUserCapabilities';
export const fetchUserCapabilities =
	(projectId: number, activationId: string, analyticsEvent: UIAnalyticsEvent) =>
	async ({ setState, getState }: StoreActionApi<State>) => {
		const initialState = { ...getState() };
		setState({
			...getState(),
			userCapabilities: { ...initialState.userCapabilities, isLoading: true },
		});
		try {
			const data = await fetchUserCapabilitiesService(projectId, activationId);
			setState({
				...getState(),
				userCapabilities: {
					...initialState.userCapabilities,
					isLoading: false,
					data,
					error: null,
				},
			});
			fireTrackAnalytics(analyticsEvent, `${EVENT_NAME} succeeded`);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...getState(),
				userCapabilities: {
					...initialState.userCapabilities,
					isLoading: false,
					error,
				},
			});
			fireErrorAnalyticsEvents(error, `${EVENT_NAME} failed`, 'knowledgeCommon');
		}
	};
